import { usePlayer } from "@/context/PlayerContext";
import { Play, Pause, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function PlayerBar() {
  const { current, playing, progress, toggle, close } = usePlayer();

  return (
    <AnimatePresence>
      {current && (
        <motion.div
          data-testid="player-bar"
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 left-0 z-50 w-full border-t border-white/10 bg-black/85 backdrop-blur-xl"
        >
          <div className="h-0.5 w-full bg-white/10">
            <div
              data-testid="player-progress"
              className="h-full bg-primary transition-[width] duration-200"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="mx-auto flex max-w-7xl items-center gap-4 px-6 py-3">
            <img
              src={current.cover}
              alt={current.title}
              data-testid="player-cover"
              className={`h-12 w-12 rounded-full border border-white/20 object-cover ${playing ? "vinyl-spin" : ""}`}
            />
            <div className="min-w-0 flex-1">
              <p data-testid="player-track-title" className="truncate font-oswald text-sm font-bold tracking-wider text-white">
                {current.title}
              </p>
              <p data-testid="player-track-album" className="truncate font-mono text-[10px] tracking-[0.2em] text-white/50">
                {current.album}
              </p>
            </div>
            <button
              data-testid="player-toggle-button"
              onClick={() => toggle(current)}
              aria-label={playing ? "Pause" : "Play"}
              className="bg-primary p-3 text-black transition-transform duration-300 hover:scale-105"
            >
              {playing ? <Pause size={18} /> : <Play size={18} />}
            </button>
            <button
              data-testid="player-close-button"
              onClick={close}
              aria-label="Close player"
              className="p-2 text-white/50 transition-colors duration-300 hover:text-white"
            >
              <X size={18} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
